export default __webpack_public_path__ + "static/banner-real-stories-saving-spending-lending-shivani-1d5c1caef2150eb3c0a0671580284f7e.jpg";